// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientEnrollmentControllerEnrollmentWithSignatureDocumentUploadResponse {
    static getAttributeTypeMap() {
        return PatientEnrollmentControllerEnrollmentWithSignatureDocumentUploadResponse.attributeTypeMap;
    }
}
PatientEnrollmentControllerEnrollmentWithSignatureDocumentUploadResponse.discriminator = undefined;
PatientEnrollmentControllerEnrollmentWithSignatureDocumentUploadResponse.additionalProperties = false;
PatientEnrollmentControllerEnrollmentWithSignatureDocumentUploadResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentV2ProcessingResultModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=patientEnrollmentControllerEnrollmentWithSignatureDocumentUploadResponse.js.map